import React from 'react';
import { Link } from 'react-router-dom';
import Marc from "../assets/Marcus.JPG";
import "../styles/Developers.css";

export const Marcus = () => {
    return(
        <div className="developer-profile-container">
            <h1 className="developer-header">About Marcus</h1>
            <img src={Marc} alt="Marcus's Portrait" className="developer-image" />
            <p className="developer-bio">
                Marcus is a Junior in Computer Science who loves web development! 
                When not doing work, he really enjoys making and collecting music. 
                He's also a huge fan of the Philadelphia Eagles (Go Birds!!!)
            </p>
            <Link to="/about" className="back-button">Back to Developers</Link>
        </div>
    );
};
